import { render, staticRenderFns } from "./ordersetting.vue?vue&type=template&id=09c4ac15&scoped=true"
import script from "./ordersetting.vue?vue&type=script&lang=js"
export * from "./ordersetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c4ac15",
  null
  
)

export default component.exports